module.exports = __webpack_public_path__ + "static/the-wizard-of-menlo-park-d79c0844ba2c4aa54fd5db5bb76c761f.jpg";